import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import PurchaseMotionButton from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionButton';
import { nonRecurringProductConfigurationsSelector, offerProductConfigurationsSelector, getFirstHubSkuIdFromProductConfigurations } from '../../../selectors/ProductConfigsSelectors';
import { useQueryParamFromLocation } from 'pricing-pages-ui/utils/urls/queryParamUtils';
import { UPGRADE_SOURCE } from 'pricing-pages-lib/constants/QueryParams';
import { crmSuiteProductLevelSelector, productForSkuIdSelector, rawProductListSelector } from '../../../selectors/ProductsSelectors';
import { usePMBOverride } from './PurchaseMotionButtonOverrideHooks';
import { Metrics } from 'pricing-pages-ui/utils/metrics';
import { BUY_TOUCHLESS } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes'; // TX-111
// @ts-expect-error Could not find a declaration file for module. ts(7016)

import { TX111_TRIAL_DURATION } from 'ui-addon-upgrades/_core/trial/constants';
import { useIsTx111VariantC } from '../../../hooks/tx111Hooks';

const setupMetricCounter = () => {
  Metrics.counter('buy-now-clicked').increment();
};

export const getPurchaseMotionForLevel = ({
  purchaseMotions,
  level
}) => purchaseMotions[level - 1];
export const filteredPropsForPBM = props => {
  const propsToPass = Object.assign({}, props);
  delete propsToPass.nonMerchandiseIdIdentifier;
  delete propsToPass.fallbackSeleniumIdentifier;
  delete propsToPass.queryParamTerm;
  delete propsToPass.productConfigurations;
  delete propsToPass.filterOwnedMarketingProducts;
  return propsToPass;
};

const PurchaseMotionButtonWrapper = props => {
  const isTx111VarC = useIsTx111VariantC();
  const {
    trackingSource,
    productConfigurations = [],
    nonMerchandiseIdIdentifier,
    fallbackSeleniumIdentifier,
    queryParamTerm,
    onClick
  } = props;
  const crmSuiteProductLevel = useSelector(state => crmSuiteProductLevelSelector(state, {
    skuIds: productConfigurations.map(({
      skuId
    }) => skuId)
  }));
  const crmSuiteSeleniumId = crmSuiteProductLevel && `crm-suite-${crmSuiteProductLevel}`;
  const apiName = useSelector(state => {
    const hubSkuId = getFirstHubSkuIdFromProductConfigurations(state, {
      productConfigurations
    });
    const product = hubSkuId && productForSkuIdSelector(state, {
      skuId: hubSkuId
    });
    return product && product.apiName;
  });
  const purchaseMotion = getPurchaseMotionForLevel(props);
  const productIdentifier = crmSuiteSeleniumId || nonMerchandiseIdIdentifier || apiName || fallbackSeleniumIdentifier;
  const offerProductConfigurations = useSelector(state => offerProductConfigurationsSelector(state, {
    productConfigurations,
    queryParamTerm
  }));
  const nonRecurringProductConfigurations = useSelector(state => nonRecurringProductConfigurationsSelector(state, {
    productConfigurations
  }));
  const rawProductList = useSelector(rawProductListSelector);
  const propsToPass = Object.assign({}, props, {
    nonRecurringProductConfigurations,
    offerProductConfigurations,
    'data-selenium-id': `${trackingSource}-${productIdentifier}-${purchaseMotion}-button`,
    nonMerchandiseIdIdentifier: crmSuiteSeleniumId || nonMerchandiseIdIdentifier,
    truncate: true,
    'data-reagan-primary-cta': true,
    shouldShowErrorAlert: true,
    products: rawProductList
  }, purchaseMotion === BUY_TOUCHLESS && {
    onClick: e => {
      if (onClick) {
        onClick(e);
      }

      setupMetricCounter();
    }
  });
  const upgradeSource = useQueryParamFromLocation(UPGRADE_SOURCE);

  if (upgradeSource) {
    propsToPass.upgradeData = Object.assign({}, propsToPass.upgradeData, {
      source: upgradeSource
    });
  }

  if (isTx111VarC) {
    propsToPass.upgradeData = Object.assign({}, propsToPass.upgradeData, {
      duration: TX111_TRIAL_DURATION
    });
  }

  return usePMBOverride(propsToPass) || /*#__PURE__*/_jsx(PurchaseMotionButton, Object.assign({}, filteredPropsForPBM(propsToPass)));
};

export default PurchaseMotionButtonWrapper;